import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type ThemeMode = 'light' | 'dark' | 'auto';

interface ThemeState {
  // 状态
  theme: ThemeMode;
  isDark: boolean;
  sidebarCollapsed: boolean;
  
  // 方法
  setTheme: (theme: ThemeMode) => void;
  toggleTheme: () => void;
  toggleSidebar: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
}

export const useThemeStore = create<ThemeState>()(
  devtools(
    (set, get) => ({
      // 初始状态
      theme: 'light',
      isDark: false,
      sidebarCollapsed: false,

      // 设置主题
      setTheme: (theme) => {
        const isDark = theme === 'dark' || 
          (theme === 'auto' && window.matchMedia('(prefers-color-scheme: dark)').matches);
        
        set({ theme, isDark });
        
        // 更新 DOM
        if (isDark) {
          document.documentElement.classList.add('dark');
        } else {
          document.documentElement.classList.remove('dark');
        }
      },

      // 切换主题
      toggleTheme: () => {
        const { theme } = get();
        const newTheme = theme === 'light' ? 'dark' : 'light';
        get().setTheme(newTheme);
      },

      // 切换侧边栏
      toggleSidebar: () => {
        set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed }));
      },

      // 设置侧边栏折叠状态
      setSidebarCollapsed: (collapsed) => {
        set({ sidebarCollapsed: collapsed });
      },
    }),
    { name: 'ThemeStore' }
  )
);
